import { useCallback, MouseEvent } from "react";
import TemplatesService from "../../../../services/administration/templates";
import { useDownloadAttachment } from "../../../../lib/hooks/useDownloadAttachment";

export const useDownload = (service: any = TemplatesService) => {
  const { isLoading, onDownload } = useDownloadAttachment(service);

  const onDownloadClick = useCallback(
    (e: MouseEvent<HTMLInputElement>, fileName: string): void => {
      e.stopPropagation();
      onDownload(e.currentTarget.id, fileName);
    },
    [onDownload]
  );

  return { isLoading, onDownloadClick, onDownload };
};
